import { connectAgentActions } from '@/redux/slices';
import { AgentStateType } from '@/redux/slices/connect';
import { getReduxStore } from '@/redux/store';

// function createDom() {
//     const newElement = document.createElement('div');
//     newElement.setAttribute('id', 'ccp-container');
//     document.body.appendChild(newElement);
// }

// // Add the call to init() as an onload so it will only run once the page is loaded
// window.onload = (event) => {
//     try {
//         createDom();
//         initializeCCP('ccp-container');
//     } catch (error) {
//         console.error('CCP initialization error', error);
//     }

// };

export function logInfoMsg(msg: string) {
  //   connect.getLog().info(msg);
}

export function logInfoEvent(eventMsg: string) {
  connect.getLog().info(eventMsg);
}

export function displayAgentStatus(status: AgentStateType) {
  const store = getReduxStore();
  store.dispatch(connectAgentActions.setAgentStatus(status));
  connect.getLog().info(status);
}
